import axios from "axios";
import { fpoTemplatesUrl, fpoTemplateDetailUrl } from "../constants/apis";
import { getAuthToken } from "../helpers/local_storage_helpers";

const authHeaders = () => ({
    headers: { Authorization: `Token ${getAuthToken()}` },
});

const writeConfig = (data) => {
    const isFormData = data instanceof FormData;
    return {
        headers: {
            Authorization: `Token ${getAuthToken()}`,
            "Content-Type": isFormData ? "multipart/form-data" : "application/json",
        },
    };
};

/**
 * GET /fpo/templates/ — list message templates visible to the caller's FPO
 * (its own templates plus any global/shared ones). Params: search, channel, page, page_size.
 */
export const getFPOTemplates = async (params = {}) => {
    const response = await axios.get(fpoTemplatesUrl, { ...authHeaders(), params });
    return response;
};

/**
 * POST /fpo/templates/ — create a template (fpo_admin only).
 * @param {FormData|Object} data — pass FormData if uploading an image.
 */
export const addFPOTemplate = async (data) => {
    const response = await axios.post(fpoTemplatesUrl, data, writeConfig(data));
    return response;
};

/**
 * PATCH /fpo/templates/<id>/ — partial update (fpo_admin only, own templates only).
 */
export const updateFPOTemplate = async (id, data) => {
    const response = await axios.patch(fpoTemplateDetailUrl(id), data, writeConfig(data));
    return response;
};

/**
 * DELETE /fpo/templates/<id>/ — (fpo_admin only, own templates only).
 */
export const deleteFPOTemplate = async (id) => {
    const response = await axios.delete(fpoTemplateDetailUrl(id), authHeaders());
    return response;
};
